/* eslint-disable react-hooks/exhaustive-deps */
import App from '../../layout/App';
import React, { useContext, useEffect, useState } from 'react';
import { FormContent, Container } from '../../styles/styles'
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './styles.css'

import Loading from '../../Components/Loading'
import MessageTitle from '../../Components/MessageTitle';
import InputSearch from '../../Components/InputSearch';
import CardPessoa from '../../Components/CardPessoa';

import turma from '../../assets/iconesMenu/icone-turma.svg'
import InfoPage from '../../Components/infoPage';
import { MessageContext } from '../../context/message';
import PaginationC from '../../Components/pagination';
import { PaginationContext } from '../../context/paginationController';

const data = sessionStorage.getItem('inep')
let dataSchoolStorage = JSON.parse(localStorage.getItem('dataSchool'))
let filter = sessionStorage.getItem('filterCE')
function PesquisarTurma() {
    const [removeLoading, setRemoveLoading] = useState(false)
    const { setErrorMessage } = useContext(MessageContext);
    const { pagination, setPagination } = useContext(PaginationContext);
    const navigation = useNavigate()
    const [todos, setTodos] = useState([]);
    const [aux, setAux] = useState([]);
    const [registerWasChanged, setRegisterWasChanged] = useState(0)
    const [filtersSelect, setFiltersSelect] = useState(0)
    const [dataSchool, setDataSchool] = useState('')
    const [configPagination, setConfigPagination] = useState({
        'currentPage': pagination.currentPage,
        'totalView': pagination.totalView,
        'totalPages': 0
    })
    async function getDataClass() {
        setRemoveLoading(false)
        await api.get(`/class/list/?inep=${data}&page=${configPagination.currentPage}&view=${configPagination.totalView}&total=${dataSchoolStorage.theAmountClass}`
        ).then(response => {
            setRegisterWasChanged(response.data.registerWasChanged)
            
            setConfigPagination({
                ...configPagination,
                totalPages: response.data.totalPages,
            })
            sessionStorage.setItem('configPageST', configPagination.currentPage)
            setAux(response.data.classes)
            setTodos(response.data.classes)
            setPagination({
                'currentPage': response.data.currentPage,
                'totalView': configPagination.totalView
            })

        }).catch((err) => {
            setErrorMessage([{ message: "Erro ao buscar turmas", ok: false }])
        })
        setRemoveLoading(true)
    }
    useEffect(() => {
        let data = JSON.parse(localStorage.getItem('dataSchool'))
        getDataClass()
        setDataSchool(data)


    }, [])


    useEffect(() => {
        filters(Number(filter))
    }, [todos])

    function filterItems(busca) {
        let Filtrados = []
        busca = busca.toUpperCase()
        if (filtersSelect !== 0) {
            Filtrados = todos.filter((turma) => turma.name.includes(busca) && turma.wasChanged === filtersSelect)
        }
        else {
            Filtrados = todos.filter((turma) => turma.name.includes(busca))

        }
        setAux(Filtrados)
    }






    function filters(tipo) {
        sessionStorage.setItem('filterCE', tipo)
       
        let list = []
        if (Number(tipo) === 1) {
            list = todos.filter((turma) => turma.wasChanged === true)
        }
        else if (Number(tipo) === 2) {
            list = todos.filter((turma) => turma.wasChanged === false)
        } 
        else if (Number(tipo) === 0) {
            list = todos
        }
        setFiltersSelect(tipo)
        setAux(list)

      
    }


    const EditTurma = (code) => {
        sessionStorage.setItem('TurmaSelecionada', code)
        navigation('/turma/Editar')
    }

    const changeCurrentPage = (numPage) => {
        setConfigPagination({ ...configPagination, currentPage: numPage });
        //fetch a data
        //or update a query to get data
    };

    useEffect(() => {
        getDataClass()
    }, [configPagination.currentPage, configPagination.totalView])


    return (
        <>
            {!removeLoading && <Loading />}
            <App>
                <Container>
                    <InfoPage
                        img={turma}
                        title={'TURMA'}
                        key={"TE7587"}
                        edited={registerWasChanged}
                        notEdited={dataSchool.theAmountClass - registerWasChanged}
                    />
                    <FormContent style={{ backgroundColor: 'transparent', border: 'none', justifyItems: 'center' }}>
                        <InputSearch
                            valueInput={e => filterItems(e.target.value)}
                            all={(e) => filters(0)}
                            edited={(e) => filters(1)}
                            notEdited={(e) => filters(2)}
                            totalNumber={`Número de turmas: ${dataSchool.theAmountClass}`}
                            checked={filtersSelect}
                        />
                        <div className='box-card'>
                            {
                                aux?.length === 0 ? <MessageTitle message={'Nenhum Dado encontrado'} /> : aux.map((item, index) => {
                                    return (
                                        <CardPessoa
                                            index={index}
                                            key={index + item.code}
                                            name={item.name}
                                            wasChanged={item.wasChanged}
                                            onClick={() => { EditTurma(item.code) }}
                                        />
                                    )
                                })}
                        </div>

                        <PaginationC
                            currentPage={configPagination.currentPage}
                            totalPages={configPagination.totalPages}
                            defaultView={configPagination.totalView}
                            onChangeView={(e) => { setConfigPagination({ ...configPagination, totalView: Number(e.target.value) }) }}
                            changeCurrentPage={(numPage) => changeCurrentPage(numPage)}
                        />
                    </FormContent>

                </Container>

            </App>
        </>
    )
}
export default PesquisarTurma;